var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoalImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 211,
    viewBox: "0 0 249 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.66 128.044H126.391C126.391 128.044 115.127 116.67 101.268 112.087C87.4088 107.504 84.3168 120.59 84.3168 120.59C84.3168 120.59 70.8443 99.2769 53.7829 96.5162C31.4208 92.9272 35.341 121.97 35.341 121.97C35.341 121.97 28.1079 117.995 22.0894 118.271C18.0587 118.437 15.5188 121.97 19.66 128.044Z",
    fill: "url(#paint0_linear_427_7574)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.941 163.105H227.824V171.222H235.941V163.105Z",
    fill: "url(#paint1_linear_427_7574)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M243.838 87.2397H239.145V91.933H243.838V87.2397Z",
    fill: "url(#paint2_linear_427_7574)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4057 43.9514H21.375V47.9821H25.4057V43.9514Z",
    fill: "url(#paint3_linear_427_7574)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M142.518 95.9087H139.426V99.0007H142.518V95.9087Z",
    fill: "url(#paint4_linear_427_7574)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.369 99.0005H132.025V106.344H139.369V99.0005Z",
    fill: "url(#paint5_linear_427_7574)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9847 169.455H67.9785V177.461H75.9847V169.455Z",
    fill: "url(#paint6_linear_427_7574)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.246 43.3989H133.24V51.4051H141.246V43.3989Z",
    fill: "url(#paint7_linear_427_7574)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1239 0H58.1484V3.97548H62.1239V0Z",
    fill: "url(#paint8_linear_427_7574)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3482 173.044H20.8203V206.836H61.3482V173.044Z",
    fill: "url(#paint9_linear_427_7574)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.588 144.664H86.8574V206.891H121.588V144.664Z",
    fill: "url(#paint10_linear_427_7574)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M161.949 206.836H127.219V176.247V116.228H161.949V170.173V206.836Z",
    fill: "url(#paint11_linear_427_7574)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M32.25 196.621L44.4525 173.044H52.1826L46.9372 196.621H32.25Z",
    fill: "url(#paint12_linear_427_7574)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M89.7832 167.634L101.931 144.664H117.28L111.98 167.634H89.7832Z",
    fill: "url(#paint13_linear_427_7574)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M214.295 88.2344H179.564V206.836H214.295V88.2344Z",
    fill: "url(#paint14_linear_427_7574)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M214.353 97.6758V98.7249C207.948 99.3875 206.789 104.854 203.862 109.547C202.151 112.197 200.053 114.185 197.457 115.179C192.046 117.222 184.482 115.952 179.623 117.498V109.05C184.979 108.167 190.887 111.259 196.077 109.713C203.31 106.897 205.74 97.0132 214.409 97.731L214.353 97.6758Z",
    fill: "url(#paint15_linear_427_7574)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M214.353 134.504V142.4C199.445 141.903 202.537 119.264 179.623 127.602V124.731C198.838 120.037 201.764 135.001 214.353 134.559V134.504Z",
    fill: "url(#paint16_linear_427_7574)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M214.353 147.701V156.48C190.556 155.541 193.372 168.627 179.623 167.523V163.824C184.095 163.989 189.893 162.167 193.648 159.517C200.384 154.713 205.298 148.75 214.353 147.646V147.701Z",
    fill: "url(#paint17_linear_427_7574)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M211.922 192.59C208.499 204.958 189.284 199.437 179.622 200.154V193.529C186.855 192.038 194.64 198.94 201.542 196.234C207.505 194.302 208.499 182.154 202.425 180.387C195.413 177.958 183.708 184.639 179.566 187.345V181.989C188.125 177.075 207.726 174.866 211.702 186.351C212.419 188.338 212.419 190.547 211.867 192.59H211.922Z",
    fill: "url(#paint18_linear_427_7574)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M198.119 35.9451L201.652 43.0678C201.818 43.4544 202.204 43.7304 202.646 43.7856L210.487 44.9452C211.536 45.1108 211.978 46.436 211.205 47.1538L205.517 52.6753C205.186 52.9513 205.076 53.3931 205.131 53.8348L206.456 61.6753C206.622 62.7244 205.517 63.5526 204.579 63.0557L197.566 59.3563C197.18 59.1354 196.738 59.1354 196.352 59.3563L189.339 63.0557C188.401 63.5526 187.241 62.7244 187.462 61.6753L188.787 53.8348C188.842 53.3931 188.732 52.9513 188.401 52.6753L182.714 47.1538C181.941 46.3807 182.382 45.0556 183.431 44.9452L191.272 43.7856C191.714 43.7304 192.045 43.4544 192.266 43.0678L195.8 35.9451C196.296 34.9512 197.677 34.9512 198.174 35.9451H198.119Z",
    fill: "url(#paint19_linear_427_7574)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M196.959 36.3311C197.069 36.3311 197.125 36.3311 197.125 36.4415L200.658 43.5643C200.99 44.2821 201.708 44.779 202.481 44.8894L210.321 46.049C210.432 46.049 210.487 46.1042 210.487 46.2146C210.487 46.2698 210.487 46.3802 210.487 46.4355L204.8 51.957C204.247 52.5091 203.971 53.3373 204.082 54.1103L205.407 61.9509C205.407 61.9509 205.407 62.0613 205.407 62.1165C205.407 62.1165 205.297 62.1717 205.241 62.1717C205.186 62.1717 205.186 62.1717 205.131 62.1717L198.119 58.4723C197.787 58.3067 197.401 58.1963 197.014 58.1963C196.628 58.1963 196.241 58.3067 195.91 58.4723L188.898 62.1717C188.898 62.1717 188.842 62.1717 188.787 62.1717C188.732 62.1717 188.677 62.1717 188.622 62.1165C188.622 62.0613 188.622 62.0061 188.622 61.9509L189.947 54.1103C190.057 53.3373 189.836 52.5091 189.229 51.957L183.542 46.4355C183.487 46.3802 183.487 46.325 183.542 46.2146C183.542 46.1594 183.597 46.1042 183.707 46.049L191.548 44.8894C192.321 44.779 193.039 44.2821 193.37 43.5643L196.904 36.4415C196.904 36.3863 197.014 36.3311 197.069 36.3311M196.959 35.2268C196.517 35.2268 196.02 35.4477 195.8 35.9446L192.266 43.0673C192.1 43.4538 191.714 43.7299 191.272 43.7851L183.431 44.9446C182.382 45.1103 181.941 46.4355 182.714 47.1533L188.401 52.6748C188.732 52.9508 188.842 53.3926 188.787 53.8343L187.462 61.6748C187.296 62.503 188.014 63.2208 188.732 63.2208C189.45 63.2208 189.119 63.2208 189.339 63.0552L196.352 59.3558C196.517 59.2453 196.738 59.1901 196.959 59.1901C197.18 59.1901 197.401 59.1901 197.566 59.3558L204.579 63.0552C204.8 63.1656 204.965 63.2208 205.186 63.2208C205.959 63.2208 206.622 62.5583 206.456 61.6748L205.131 53.8343C205.076 53.3926 205.186 52.9508 205.517 52.6748L211.205 47.1533C211.978 46.3802 211.536 45.0551 210.487 44.9446L202.646 43.7851C202.204 43.7299 201.873 43.4538 201.652 43.0673L198.119 35.9446C197.898 35.4477 197.401 35.2268 196.959 35.2268Z",
    fill: "url(#paint20_linear_427_7574)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M204.577 63.0002L199.221 60.1843L183.816 44.7793L190.774 43.7854L206.013 59.0247L206.455 61.6199C206.62 62.6689 205.516 63.4972 204.577 63.0002Z",
    fill: "url(#paint21_linear_427_7574)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M205.515 52.6752C205.184 52.9513 205.073 53.393 205.129 53.8347L205.405 55.4912L192.484 42.5709L194.03 39.3684L206.399 51.7366L205.46 52.62L205.515 52.6752Z",
    fill: "url(#paint22_linear_427_7574)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M212.75 70.1233H180.891V71.7245H212.75V70.1233Z",
    fill: "url(#paint23_linear_427_7574)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M212.75 81.6631H180.891V83.2643H212.75V81.6631Z",
    fill: "url(#paint24_linear_427_7574)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M214.351 71.7241H212.75V81.6628H214.351V71.7241Z",
    fill: "url(#paint25_linear_427_7574)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.945 71.7241H179.344V81.6628H180.945V71.7241Z",
    fill: "url(#paint26_linear_427_7574)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3659 45.608C85.3107 47.0436 85.3107 48.5344 85.3659 49.7492C85.4211 51.4608 85.5315 52.6756 85.5315 52.6756C80.01 52.6756 76.918 49.5283 76.918 49.5283C78.0223 47.4853 78.9609 40.9148 78.9609 40.9148C79.237 39.2031 86.0285 40.197 85.5315 43.8411C85.4763 44.3933 85.4211 45.0007 85.3659 45.608Z",
    fill: "#F39C94"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3674 49.749C81.1159 48.479 80.2324 45.387 80.2324 45.387C80.2324 45.387 83.1036 45.4974 85.3674 45.6078C85.3122 47.0434 85.3122 48.5342 85.3674 49.749Z",
    fill: "#F39C94"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1453 40.804C93.7588 39.7549 92.4889 38.0433 92.4889 38.0433C91.7159 34.7303 90.3355 31.4727 89.3416 29.761C85.8631 23.9634 72.1698 33.0739 77.0839 40.6936C78.9612 43.5648 81.3907 49.6936 89.5073 48.2028C92.3233 47.7059 93.2067 45.1108 93.0963 42.0187C93.7588 41.7427 94.3662 41.3009 94.2006 40.7488L94.1453 40.804Z",
    fill: "#F39C94"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1217 34.013C69.6861 32.1356 66.5941 28.7675 61.7904 30.4792C55.9376 32.5774 59.3057 41.8535 55.2198 43.013C52.0725 43.8964 53.1768 46.4363 57.9805 45.1664C66.1523 43.013 63.7781 38.1541 68.8579 37.4363C71.7843 36.9946 71.7843 34.786 71.1769 34.013H71.1217Z",
    fill: "url(#paint27_linear_427_7574)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0116 31.0864C71.0116 31.0864 68.3613 31.4729 67.9748 35.1171C67.5883 38.7613 70.1834 39.5895 70.1834 39.5895L71.0116 31.1416V31.0864Z",
    fill: "#5869F1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7615 27.1105C87.9639 27.6074 88.737 36.1105 82.4424 37.767C80.013 38.4296 78.0252 36.5523 77.197 38.7057C76.5344 40.3621 79.0191 43.3437 79.0191 43.3437C79.0191 43.3437 77.9148 46.2701 74.3258 45.9388C70.7369 45.6627 69.1356 42.902 69.1908 38.5952C69.1908 34.2884 69.5221 30.5338 73.9945 28.1044C78.467 25.6749 83.7124 26.9448 84.7615 27.1105Z",
    fill: "url(#paint28_linear_427_7574)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1451 28.8224C85.0899 27.8286 85.9181 26.1721 88.6237 26.669C92.1574 27.3316 92.6544 32.1353 90.501 34.3991C90.501 34.3991 90.1697 33.7366 89.5623 33.2948C88.1267 32.301 85.3108 31.1967 85.1451 28.8224Z",
    fill: "url(#paint29_linear_427_7574)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M111.648 71.2275C111.648 71.2275 114.298 69.6263 115.403 69.295C116.507 68.9637 117.611 69.1846 118.55 68.8533C119.489 68.522 120.096 67.3625 121.642 67.0312C123.188 66.6999 122.525 65.5404 121.421 65.43C120.262 65.2643 118.053 66.3686 118.439 65.3747C118.439 65.3747 119.875 63.9944 120.372 63.1109C121.752 63.1662 123.409 63.0005 123.906 62.8349C124.679 62.5588 125.065 61.841 124.403 61.6753C123.078 61.3441 120.593 61.0128 119.709 61.2336C118.329 61.6201 115.623 64.3809 114.354 65.3747C113.084 66.3686 108.832 68.1907 108.832 68.1907L111.648 71.2275Z",
    fill: "#F39C94"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9548 60.6817C79.4579 66.8658 85.0346 78.1849 90.0591 80.5039C95.9119 83.2094 114.575 69.6266 114.575 69.6266L112.973 65.9824C112.973 65.9824 98.8383 69.24 95.9119 71.3934C95.1941 68.6879 94.5868 63.0007 90.28 58.197C87.0775 54.5528 80.2861 55.9332 79.9548 60.6817Z",
    fill: "url(#paint30_linear_427_7574)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9186 49.5281C76.9186 49.5281 74.434 49.5833 71.9493 54.7183C69.4646 59.8533 70.6241 66.4239 68.3051 73.8227C65.9861 81.2215 63.9983 81.332 63.3358 84.0927C63.0597 85.197 64.6057 88.3995 64.6057 88.3995L81.2806 93.8658C81.2806 93.8658 82.1641 91.8228 82.9371 90.3872C85.4218 88.786 90.612 79.3442 91.8819 71.6693C93.5936 61.5098 91.1089 56.3748 85.5322 52.6202C85.5322 52.6202 79.1825 51.295 76.9186 49.4729V49.5281Z",
    fill: "url(#paint31_linear_427_7574)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1899 62.0615C78.1899 62.0615 74.7665 66.8652 69.3555 69.4051C69.7972 66.9204 69.9628 64.6014 70.1837 62.3928L78.1899 62.0615Z",
    fill: "url(#paint32_linear_427_7574)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6977 84.8654C49.6977 84.8654 47.8756 88.1231 46.9369 89.1722C45.9983 90.2765 43.5136 93.1477 41.5259 94.1968C41.305 94.3072 40.7529 94.4728 40.3664 94.5281C39.4277 94.6937 38.1025 94.6937 37.9921 94.5281C37.5504 93.7551 39.3173 93.6446 39.8142 93.3133C40.1455 93.0373 40.4768 92.7612 40.8081 92.3747C40.0903 92.6508 39.6486 92.5403 39.3725 92.3195C39.2068 92.1538 39.1516 91.933 39.2068 91.7673C39.4277 91.2152 40.3111 90.8287 40.6976 90.4974C41.0841 90.1109 41.8019 89.2826 41.8019 89.2826L41.9124 89.0618C42.7406 87.571 43.9001 87.6262 44.0658 87.4053C44.2314 87.1845 45.3909 84.5894 45.3909 84.5894L49.6977 84.9206V84.8654Z",
    fill: "#F39C94"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8577 89.7246C41.8577 89.7246 41.8577 90.1663 41.5816 90.7185C41.1951 91.7124 40.8086 92.3197 40.8086 92.3197C40.0908 92.5958 39.6491 92.4854 39.373 92.2645C40.9191 92.4854 41.8577 89.7246 41.8577 89.7246Z",
    fill: "#F39C94"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9326 51.9578C68.8037 51.9578 59.638 57.0928 56.049 63.2768C50.3619 67.8597 44.7852 85.6389 44.7852 85.6389L48.6502 87.8475C48.6502 87.8475 62.2331 73.2708 61.7914 68.9088C64.3865 67.9701 73.7178 66.7002 78.1903 62.0621C81.5584 58.5836 79.6811 51.9578 74.9326 51.9578Z",
    fill: "url(#paint33_linear_427_7574)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0104 151.896L41.084 161.338L45.8325 162.939L49.9184 154.989",
    fill: "#F39C94"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8582 101.209C77.8582 101.209 77.3061 103.418 76.3674 106.675C75.6496 109.271 74.711 112.528 73.6619 115.841C71.8398 121.639 69.7968 127.547 68.1404 130.307C66.2078 133.455 47.5452 160.068 47.5452 160.068L42.4102 155.32C42.4102 155.32 48.3182 128.541 57.9256 126.056C56.6004 109.05 61.0728 94.8042 61.0728 94.8042L77.803 101.209H77.8582Z",
    fill: "url(#paint34_linear_427_7574)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M76.368 106.676C75.6502 109.271 74.7115 112.529 73.6625 115.841C63.6685 113.246 60.1348 106.621 60.1348 106.621L61.7912 103.915C61.7912 103.915 70.8465 105.682 71.3434 105.682C71.8404 105.682 73.9385 106.179 76.368 106.676Z",
    fill: "url(#paint35_linear_427_7574)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M101.158 134.228L102.263 138.258L107.508 138.038L106.901 133.289",
    fill: "#F39C94"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6053 88.4546C64.6053 88.4546 54.9979 92.927 58.6973 104.246C61.955 114.24 91.3846 110.375 91.3846 110.375C91.3846 110.375 91.7159 114.516 92.8754 118.602C94.2006 123.24 101.047 135.332 101.047 135.332L108.17 135.829C108.17 135.829 104.581 109.712 102.704 104.08C100.826 98.4485 81.2802 93.9209 81.2802 93.9209L64.6053 88.4546Z",
    fill: "url(#paint36_linear_427_7574)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6841 38.5402C78.2976 38.5402 77.8007 39.0371 77.9664 40.031C78.1872 41.3561 79.8437 41.4666 80.5615 40.804C80.8928 40.4727 80.7271 40.1414 80.451 40.031C80.2302 39.9206 79.7884 39.9758 79.5124 39.8101C78.9602 39.4236 79.3467 38.485 78.6841 38.5402Z",
    fill: "#F39C94"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M102.263 138.258C102.263 138.258 100.938 139.915 100.607 141.24C100.276 142.565 101.987 144.608 101.987 144.608H117.337C117.337 144.608 117.779 142.952 116.619 141.682C116.233 141.295 114.687 140.467 112.754 140.578C109.994 139.252 107.564 137.982 107.564 137.982L102.319 138.203L102.263 138.258Z",
    fill: "url(#paint37_linear_427_7574)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0843 161.338L45.8328 162.94L47.6549 169.565C47.6549 169.565 50.1396 169.345 51.3543 170.062C52.5138 170.78 52.2378 173.099 52.2378 173.099H44.4525L37.1641 166.529C37.1641 166.529 37.2193 164.375 38.1027 162.995C38.5997 162.167 40.0905 161.559 41.0843 161.394V161.338Z",
    fill: "url(#paint38_linear_427_7574)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5557 37.4912C90.6661 37.8777 90.5557 38.2642 90.3348 38.3194C90.1139 38.3747 89.7827 38.1538 89.6722 37.7673C89.5618 37.3808 89.6722 36.9943 89.8931 36.9391C90.1139 36.8838 90.4452 37.1047 90.5557 37.4912Z",
    fill: "url(#paint39_linear_427_7574)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5016 36.0001C90.3359 35.8897 90.0598 35.7792 89.839 35.7792C89.6181 35.7792 89.3421 35.8897 89.1212 36.0001C88.6243 36.2762 88.2377 36.7731 87.9617 37.3253C87.9617 37.3805 87.8512 37.3805 87.796 37.3253C87.796 37.3253 87.7408 37.27 87.796 37.2148C87.9617 36.6075 88.3482 36.0001 88.9003 35.5584C89.1764 35.3375 89.5077 35.1719 89.9494 35.1719C90.3359 35.1719 90.7224 35.3375 90.9985 35.6136C91.1089 35.724 91.1089 35.8897 90.9985 36.0001C90.8881 36.1105 90.7224 36.1105 90.612 36.0001H90.5016Z",
    fill: "url(#paint40_linear_427_7574)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M92.047 43.0125L89.1758 43.2333C89.1758 43.2333 89.8384 44.5585 91.2187 44.5585C92.5991 44.5585 92.047 43.0125 92.047 43.0125Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M153.504 84.9209C150.467 84.9209 147.982 87.4056 147.982 90.4424C147.982 87.4056 145.498 84.9209 142.461 84.9209C145.498 84.9209 147.982 82.4362 147.982 79.3994C147.982 82.4362 150.467 84.9209 153.504 84.9209Z",
    fill: "url(#paint41_linear_427_7574)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M248.086 33.6266C242.289 33.6266 237.54 38.3199 237.54 44.1727C237.54 38.3751 232.847 33.6266 226.994 33.6266C232.792 33.6266 237.54 28.9334 237.54 23.0806C237.54 28.8781 242.233 33.6266 248.086 33.6266Z",
    fill: "url(#paint42_linear_427_7574)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M226.553 118.326C221.805 118.326 217.94 122.191 217.94 126.94C217.94 122.191 214.075 118.326 209.326 118.326C214.075 118.326 217.94 114.461 217.94 109.713C217.94 114.461 221.805 118.326 226.553 118.326Z",
    fill: "url(#paint43_linear_427_7574)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6558 58.5281C9.1711 58.5281 7.18336 60.5158 7.18336 63.0005C7.18336 60.5158 5.19561 58.5281 2.71094 58.5281C5.19561 58.5281 7.18336 56.5403 7.18336 54.0557C7.18336 56.5403 9.1711 58.5281 11.6558 58.5281Z",
    fill: "url(#paint44_linear_427_7574)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M131.748 21.3134C129.153 21.3134 127.055 23.4116 127.055 26.0067C127.055 23.4116 124.956 21.3134 122.361 21.3134C124.956 21.3134 127.055 19.2152 127.055 16.6201C127.055 19.2152 129.153 21.3134 131.748 21.3134Z",
    fill: "url(#paint45_linear_427_7574)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9891 138.259C28.167 138.259 26.6762 139.75 26.6762 141.572C26.6762 139.75 25.1854 138.259 23.3633 138.259C25.1854 138.259 26.6762 136.768 26.6762 134.946C26.6762 136.768 28.167 138.259 29.9891 138.259Z",
    fill: "url(#paint46_linear_427_7574)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1 206.946H241.517",
    stroke: "#282734",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6797 210.48H138.815",
    stroke: "#282734",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9863 210.48H52.1828",
    stroke: "#282734",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M183.223 78.5388C183.178 78.5388 183.143 78.5265 183.119 78.5018C183.094 78.473 183.082 78.4381 183.082 78.397V74.3631C183.082 74.322 183.094 74.2891 183.119 74.2644C183.143 74.2356 183.178 74.2212 183.223 74.2212H183.55C183.591 74.2212 183.624 74.2356 183.649 74.2644C183.674 74.2891 183.686 74.322 183.686 74.3631V78.0022H185.74C185.785 78.0022 185.82 78.0166 185.845 78.0454C185.869 78.0701 185.882 78.105 185.882 78.1502V78.397C185.882 78.4381 185.869 78.473 185.845 78.5018C185.82 78.5265 185.785 78.5388 185.74 78.5388H183.223ZM187.687 78.6005C187.264 78.6005 186.927 78.471 186.676 78.2119C186.425 77.9487 186.287 77.591 186.263 77.1387C186.258 77.0852 186.256 77.0174 186.256 76.9351C186.256 76.8488 186.258 76.7789 186.263 76.7254C186.279 76.4335 186.347 76.1785 186.466 75.9606C186.585 75.7385 186.748 75.5679 186.953 75.4486C187.163 75.3294 187.408 75.2698 187.687 75.2698C188 75.2698 188.261 75.3356 188.471 75.4672C188.685 75.5987 188.847 75.7858 188.958 76.0284C189.069 76.2711 189.125 76.5548 189.125 76.8796V76.9845C189.125 77.0297 189.11 77.0647 189.081 77.0893C189.057 77.114 189.024 77.1263 188.983 77.1263H186.849C186.849 77.1305 186.849 77.1387 186.849 77.151C186.849 77.1634 186.849 77.1736 186.849 77.1819C186.857 77.3505 186.894 77.5088 186.96 77.6568C187.025 77.8007 187.12 77.9179 187.243 78.0084C187.367 78.0988 187.515 78.1441 187.687 78.1441C187.835 78.1441 187.959 78.1215 188.057 78.0762C188.156 78.031 188.236 77.9816 188.298 77.9282C188.36 77.8706 188.401 77.8274 188.421 77.7987C188.458 77.7452 188.487 77.7144 188.508 77.7061C188.528 77.6938 188.561 77.6876 188.606 77.6876H188.902C188.944 77.6876 188.977 77.7 189.001 77.7246C189.03 77.7452 189.042 77.776 189.038 77.8172C189.034 77.8788 189.001 77.9549 188.939 78.0454C188.878 78.1317 188.789 78.2181 188.674 78.3044C188.559 78.3908 188.419 78.4627 188.255 78.5203C188.09 78.5738 187.901 78.6005 187.687 78.6005ZM186.849 76.7008H188.539V76.6823C188.539 76.4972 188.504 76.3327 188.434 76.1888C188.368 76.0449 188.271 75.9318 188.144 75.8496C188.016 75.7632 187.864 75.72 187.687 75.72C187.511 75.72 187.358 75.7632 187.231 75.8496C187.108 75.9318 187.013 76.0449 186.947 76.1888C186.881 76.3327 186.849 76.4972 186.849 76.6823V76.7008ZM190.87 78.5388C190.808 78.5388 190.759 78.5244 190.722 78.4956C190.689 78.4669 190.662 78.4299 190.642 78.3846L189.501 75.5227C189.493 75.5021 189.488 75.4815 189.488 75.461C189.488 75.424 189.501 75.3931 189.525 75.3685C189.55 75.3438 189.581 75.3315 189.618 75.3315H189.914C189.959 75.3315 189.994 75.3438 190.019 75.3685C190.044 75.3931 190.058 75.4158 190.062 75.4363L191.006 77.8665L191.943 75.4363C191.951 75.4158 191.966 75.3931 191.986 75.3685C192.011 75.3438 192.046 75.3315 192.091 75.3315H192.394C192.426 75.3315 192.455 75.3438 192.48 75.3685C192.509 75.3931 192.523 75.424 192.523 75.461C192.523 75.4815 192.519 75.5021 192.511 75.5227L191.363 78.3846C191.347 78.4299 191.32 78.4669 191.283 78.4956C191.25 78.5244 191.201 78.5388 191.135 78.5388H190.87ZM194.331 78.6005C193.908 78.6005 193.571 78.471 193.32 78.2119C193.069 77.9487 192.931 77.591 192.906 77.1387C192.902 77.0852 192.9 77.0174 192.9 76.9351C192.9 76.8488 192.902 76.7789 192.906 76.7254C192.923 76.4335 192.991 76.1785 193.11 75.9606C193.229 75.7385 193.392 75.5679 193.597 75.4486C193.807 75.3294 194.052 75.2698 194.331 75.2698C194.644 75.2698 194.905 75.3356 195.115 75.4672C195.328 75.5987 195.491 75.7858 195.602 76.0284C195.713 76.2711 195.768 76.5548 195.768 76.8796V76.9845C195.768 77.0297 195.754 77.0647 195.725 77.0893C195.701 77.114 195.668 77.1263 195.627 77.1263H193.492C193.492 77.1305 193.492 77.1387 193.492 77.151C193.492 77.1634 193.492 77.1736 193.492 77.1819C193.501 77.3505 193.538 77.5088 193.603 77.6568C193.669 77.8007 193.764 77.9179 193.887 78.0084C194.011 78.0988 194.159 78.1441 194.331 78.1441C194.479 78.1441 194.603 78.1215 194.701 78.0762C194.8 78.031 194.88 77.9816 194.942 77.9282C195.004 77.8706 195.045 77.8274 195.065 77.7987C195.102 77.7452 195.131 77.7144 195.152 77.7061C195.172 77.6938 195.205 77.6876 195.25 77.6876H195.546C195.587 77.6876 195.62 77.7 195.645 77.7246C195.674 77.7452 195.686 77.776 195.682 77.8172C195.678 77.8788 195.645 77.9549 195.583 78.0454C195.522 78.1317 195.433 78.2181 195.318 78.3044C195.203 78.3908 195.063 78.4627 194.899 78.5203C194.734 78.5738 194.545 78.6005 194.331 78.6005ZM193.492 76.7008H195.182V76.6823C195.182 76.4972 195.147 76.3327 195.078 76.1888C195.012 76.0449 194.915 75.9318 194.788 75.8496C194.66 75.7632 194.508 75.72 194.331 75.72C194.154 75.72 194.002 75.7632 193.875 75.8496C193.751 75.9318 193.657 76.0449 193.591 76.1888C193.525 76.3327 193.492 76.4972 193.492 76.6823V76.7008ZM196.654 78.5388C196.613 78.5388 196.578 78.5265 196.549 78.5018C196.524 78.473 196.512 78.4381 196.512 78.397V74.3014C196.512 74.2603 196.524 74.2274 196.549 74.2027C196.578 74.1739 196.613 74.1595 196.654 74.1595H196.944C196.989 74.1595 197.024 74.1739 197.049 74.2027C197.073 74.2274 197.086 74.2603 197.086 74.3014V78.397C197.086 78.4381 197.073 78.473 197.049 78.5018C197.024 78.5265 196.989 78.5388 196.944 78.5388H196.654ZM201.226 78.6005C200.881 78.6005 200.583 78.5388 200.332 78.4155C200.085 78.2921 199.894 78.105 199.758 77.8542C199.627 77.5992 199.561 77.2723 199.561 76.8735V74.3692C199.561 74.324 199.573 74.2891 199.598 74.2644C199.622 74.2356 199.657 74.2212 199.703 74.2212H200.017C200.062 74.2212 200.097 74.2356 200.122 74.2644C200.151 74.2891 200.165 74.324 200.165 74.3692V76.8858C200.165 77.2888 200.26 77.5869 200.449 77.7802C200.638 77.9734 200.897 78.0701 201.226 78.0701C201.551 78.0701 201.808 77.9734 201.997 77.7802C202.19 77.5869 202.287 77.2888 202.287 76.8858V74.3692C202.287 74.324 202.299 74.2891 202.324 74.2644C202.353 74.2356 202.388 74.2212 202.429 74.2212H202.75C202.791 74.2212 202.824 74.2356 202.848 74.2644C202.877 74.2891 202.892 74.324 202.892 74.3692V76.8735C202.892 77.2723 202.824 77.5992 202.688 77.8542C202.556 78.105 202.367 78.2921 202.121 78.4155C201.874 78.5388 201.576 78.6005 201.226 78.6005ZM203.99 79.7107C203.949 79.7107 203.914 79.6963 203.886 79.6676C203.861 79.6429 203.849 79.61 203.849 79.5689V75.4733C203.849 75.4322 203.861 75.3993 203.886 75.3746C203.914 75.3459 203.949 75.3315 203.99 75.3315H204.274C204.315 75.3315 204.348 75.3459 204.373 75.3746C204.402 75.3993 204.416 75.4322 204.416 75.4733V75.7447C204.515 75.609 204.646 75.4959 204.811 75.4055C204.975 75.315 205.181 75.2698 205.428 75.2698C205.658 75.2698 205.853 75.3088 206.014 75.387C206.178 75.4651 206.312 75.572 206.415 75.7077C206.521 75.8434 206.602 75.9976 206.655 76.1703C206.709 76.343 206.737 76.5281 206.741 76.7254C206.746 76.7912 206.748 76.8611 206.748 76.9351C206.748 77.0092 206.746 77.0791 206.741 77.1449C206.737 77.3381 206.709 77.5232 206.655 77.7C206.602 77.8727 206.521 78.0269 206.415 78.1626C206.312 78.2942 206.178 78.4011 206.014 78.4833C205.853 78.5614 205.658 78.6005 205.428 78.6005C205.189 78.6005 204.988 78.5573 204.823 78.471C204.663 78.3805 204.531 78.2695 204.428 78.1379V79.5689C204.428 79.61 204.416 79.6429 204.391 79.6676C204.367 79.6963 204.332 79.7107 204.287 79.7107H203.99ZM205.298 78.1009C205.512 78.1009 205.678 78.0557 205.798 77.9652C205.921 77.8706 206.009 77.7493 206.063 77.6013C206.116 77.4491 206.147 77.2867 206.155 77.114C206.16 76.9948 206.16 76.8755 206.155 76.7563C206.147 76.5836 206.116 76.4232 206.063 76.2752C206.009 76.123 205.921 76.0017 205.798 75.9113C205.678 75.8167 205.512 75.7694 205.298 75.7694C205.097 75.7694 204.932 75.8167 204.805 75.9113C204.681 76.0058 204.589 76.1271 204.527 76.2752C204.47 76.4191 204.437 76.5671 204.428 76.7193C204.424 76.7851 204.422 76.8632 204.422 76.9536C204.422 77.0441 204.424 77.1243 204.428 77.1942C204.433 77.3381 204.465 77.48 204.527 77.6198C204.593 77.7596 204.69 77.8747 204.817 77.9652C204.944 78.0557 205.105 78.1009 205.298 78.1009ZM207.671 77.5149C207.63 77.5149 207.595 77.5026 207.566 77.4779C207.541 77.4491 207.529 77.4142 207.529 77.3731V74.3631C207.529 74.322 207.541 74.2891 207.566 74.2644C207.595 74.2356 207.63 74.2212 207.671 74.2212H207.961C208.002 74.2212 208.035 74.2356 208.06 74.2644C208.084 74.2891 208.097 74.322 208.097 74.3631V77.3731C208.097 77.4142 208.084 77.4491 208.06 77.4779C208.035 77.5026 208.002 77.5149 207.961 77.5149H207.671ZM207.615 78.5388C207.574 78.5388 207.539 78.5265 207.511 78.5018C207.486 78.473 207.474 78.4381 207.474 78.397V78.0084C207.474 77.9631 207.486 77.9282 207.511 77.9035C207.539 77.8747 207.574 77.8603 207.615 77.8603H208.01C208.051 77.8603 208.084 77.8747 208.109 77.9035C208.138 77.9282 208.152 77.9631 208.152 78.0084V78.397C208.152 78.4381 208.138 78.473 208.109 78.5018C208.084 78.5265 208.051 78.5388 208.01 78.5388H207.615Z",
    fill: "#000C43"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_7574",
    x1: 72.0038,
    y1: 138.369,
    x2: 72.0038,
    y2: 107.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_7574",
    x1: 239.64,
    y1: 174.921,
    x2: 232.021,
    y2: 167.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_427_7574",
    x1: 246.046,
    y1: 94.0864,
    x2: 241.574,
    y2: 89.6692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_427_7574",
    x1: 27.283,
    y1: 49.8594,
    x2: 23.4732,
    y2: 46.0496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_427_7574",
    x1: 143.898,
    y1: 100.381,
    x2: 141.027,
    y2: 97.5099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_427_7574",
    x1: 142.792,
    y1: 109.712,
    x2: 135.835,
    y2: 102.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_427_7574",
    x1: 79.6841,
    y1: 181.105,
    x2: 72.1196,
    y2: 173.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_427_7574",
    x1: 144.946,
    y1: 55.1045,
    x2: 137.381,
    y2: 47.5401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_427_7574",
    x1: 63.946,
    y1: 5.79758,
    x2: 60.1914,
    y2: 2.04296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6F4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_427_7574",
    x1: 40.4217,
    y1: 203.523,
    x2: 42.0229,
    y2: 171.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CCEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93FFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_427_7574",
    x1: 104.25,
    y1: 207.278,
    x2: 104.25,
    y2: 147.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CCEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93FFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_427_7574",
    x1: 144.556,
    y1: 206.008,
    x2: 144.556,
    y2: 117.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4CCEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93FFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_427_7574",
    x1: 42.2439,
    y1: 172.547,
    x2: 42.2439,
    y2: 193.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A939F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E559FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_427_7574",
    x1: 103.532,
    y1: 144.112,
    x2: 103.532,
    y2: 164.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A939F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E559FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_427_7574",
    x1: 188.233,
    y1: 79.6785,
    x2: 254.686,
    y2: 192.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_427_7574",
    x1: 188.305,
    y1: 96.2458,
    x2: 190.772,
    y2: 121.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_427_7574",
    x1: 188.291,
    y1: 122.478,
    x2: 190.465,
    y2: 146.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_427_7574",
    x1: 188.291,
    y1: 146.207,
    x2: 190.792,
    y2: 171.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_427_7574",
    x1: 187.727,
    y1: 176.35,
    x2: 191.179,
    y2: 205.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_427_7574",
    x1: 205.573,
    y1: 60.0741,
    x2: 188.898,
    y2: 43.3991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_427_7574",
    x1: 182.327,
    y1: 49.1962,
    x2: 211.591,
    y2: 49.1962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_427_7574",
    x1: 216.559,
    y1: 73.5463,
    x2: 188.068,
    y2: 45.0554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_427_7574",
    x1: 213.853,
    y1: 61.5649,
    x2: 194.417,
    y2: 42.0739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89DFD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_427_7574",
    x1: 215.455,
    y1: 77.5221,
    x2: 180.835,
    y2: 65.2643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_427_7574",
    x1: 211.811,
    y1: 87.792,
    x2: 177.191,
    y2: 75.5343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_427_7574",
    x1: 215.511,
    y1: 77.3561,
    x2: 180.891,
    y2: 65.1536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_427_7574",
    x1: 211.755,
    y1: 87.9021,
    x2: 177.135,
    y2: 75.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_427_7574",
    x1: 53.4529,
    y1: 37.7676,
    x2: 71.453,
    y2: 37.7676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16203C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_427_7574",
    x1: 74.878,
    y1: 29.2639,
    x2: 81.3934,
    y2: 41.8529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16203C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_427_7574",
    x1: 85.4764,
    y1: 23.7426,
    x2: 92.047,
    y2: 36.3869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16203C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_427_7574",
    x1: 107.35,
    y1: 73.5387,
    x2: 79.7599,
    y2: 59.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_427_7574",
    x1: 70.5689,
    y1: 46.2704,
    x2: 84.5383,
    y2: 99.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_427_7574",
    x1: 71.5604,
    y1: 61.5318,
    x2: 72.8797,
    y2: 70.7719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_427_7574",
    x1: 53.5497,
    y1: 49.3687,
    x2: 61.3967,
    y2: 94.0704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9277"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E53E14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_427_7574",
    x1: 57.5391,
    y1: 77.4115,
    x2: 62.5084,
    y2: 173.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C134B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_427_7574",
    x1: 67.9201,
    y1: 99.8291,
    x2: 69.2452,
    y2: 125.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C134B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_427_7574",
    x1: 80.6729,
    y1: 72.6079,
    x2: 85.8631,
    y2: 174.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C134B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_427_7574",
    x1: 108.227,
    y1: 136.602,
    x2: 109.11,
    y2: 144.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C134B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_427_7574",
    x1: 41.8573,
    y1: 160.786,
    x2: 45.8328,
    y2: 172.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C134B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_427_7574",
    x1: 88.9544,
    y1: 36.9943,
    x2: 92.6538,
    y2: 38.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16203C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_427_7574",
    x1: 88.2377,
    y1: 35.8897,
    x2: 90.3359,
    y2: 36.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D2F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16203C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_427_7574",
    x1: 142.516,
    y1: 84.9209,
    x2: 153.504,
    y2: 84.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_427_7574",
    x1: 242.896,
    y1: 38.5408,
    x2: 232.129,
    y2: 28.6021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_427_7574",
    x1: 209.326,
    y1: 118.326,
    x2: 226.553,
    y2: 118.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_427_7574",
    x1: 11.8214,
    y1: 63.1109,
    x2: 5.47169,
    y2: 56.8164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_427_7574",
    x1: 131.858,
    y1: 26.1171,
    x2: 125.233,
    y2: 19.4913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_427_7574",
    x1: 30.0995,
    y1: 141.627,
    x2: 25.4062,
    y2: 136.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalImg);
export default __webpack_public_path__ + "static/media/goalImg.b4f96974e8c6ae93d8c9720e56c91660.svg";
export { ForwardRef as ReactComponent };